import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.scss'],
    standalone: false
})
export class SideNavComponent implements OnInit {
  @Input() accountExist: any;
  @Input() gdoPortalActive:any;

  // Change this to turnary operation for changing links dynamically
  navItemLink =[
    "/gdo/"
  ]
  constructor() { }

  ngOnInit(): void {

    }

}
